<template>
	<v-container fluid>
		<div class="bottom-buttons-outer">
			<v-btn color="success" @click="backClick">
				<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
			</v-btn>
			<v-btn color="success" @click="saveClick">
				<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
			</v-btn>
		</div>
		<v-layout row wrap>
			<v-flex md4 xs10 offset-md1>
				<span style="display:inline-block; padding:10px; margin-top:5px; color:grey; font-size:15px;"><b>{{$t('labels.codebooksAdditionalInfo')}}</b></span><br><br>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			<v-flex xs6 offset-md1>
				<v-card v-for="(item, key) in info" :key="key"
						class="mt-4">
					<v-card-text>
						<div class="subheading mb-2"><b>{{ item.language }}</b></div>
						<Editor
							:init="$tinymceInitSmall5"
							v-model="item.text"></Editor>
					</v-card-text>
				</v-card>
			</v-flex>
		</v-layout>
		<v-layout row wrap>
			&nbsp;
		</v-layout>
	</v-container>
</template>

<script>
import Editor from '@tinymce/tinymce-vue';
import InputField from "./trinkets/InputField";

export default {
	name: "codebooksHeating",
	components: {InputField, Editor},
	data: function () {
		return {
			info: []
		}
	},
	methods: {
		backClick(){
			this.$router.push('/codebooks/');
		},
		saveClick(){
			let vm = this;
			this.$APICall('put', 'codebooks/additionalInfo', this.info, (data, success) => {
				if (success) {
					vm.$notify(vm.$t('alerts.basicUpdate'));
					vm.backClick();
				} else {
					vm.$alert(vm.$t('alerts.basicError'));
				}
			});
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$setSubMenu('Settings');
		this.$myStore.commit('setBreadcrumbs', [
			{text: this.$t('modules.codebooks'), href: '/#/codebooks', disabled: false},
			{text: this.$t('labels.codebooksHeating'), href: '/#/codebooks', disabled: true},
		]);
		let vm = this;
		this.$APICall('get', 'codebooks/additionalInfo', {}, (data, success) => {
			if (success) {
				let usableData = JSON.parse(JSON.stringify(data));
				vm.info = usableData;
			}
		});
	}
}
</script>

<style scoped>
</style>
